import { Bar, BarChart, Cell, LabelList, ResponsiveContainer, XAxis, YAxis } from "recharts";
import type { Props as RechartsLabelProps } from "recharts/types/component/Label";

import { BUCKET_COLORS, ChartDataType, chartMaxValues } from "@/shared/components/charts/utils/chartUtils";

import "../styles/chartStyles.css";
import { getStrengthFromScore } from "@/shared/components/assessment/StrengthPill/StrengthPill";

export interface IBarResponsiveProps {
  labelWidth?: number;
  containerWidth?: string;
  barHeight?: number;
}

interface IBarChart {
  yAxisWidth?: number;
  hideXAxis?: boolean;
  barHeight?: number;
  min_max?: [number, number];
  usersChartData: [
    {
      value: number;
    },
  ];
}

const CustomLabel = (props: RechartsLabelProps) => {
  const { x, y, width, value } = props;
  if (value == null) return null;

  const thumbWidth = 24;
  const thumbHeight = 24;

  // end of the bar (horizontal bar, layout="vertical")
  const centerX = Number(x) + Number(width);
  const thumbX = centerX - thumbWidth / 2;
  const thumbY = Number(y) - thumbHeight - 4; // slightly above the bar

  return (
    <g>
      <rect x={thumbX} y={thumbY + 22} width={thumbWidth + 8} height={thumbHeight + 8} rx={4} ry={4} fill="#000" />
      <text
        x={centerX + 4}
        y={thumbY + thumbHeight / 2 + 3 + 25}
        textAnchor="middle"
        fill="#fff"
        fontSize={12}
        fontWeight={"bold"}
      >
        {value}
      </text>
    </g>
  );
};

export default function AssessmentTemplateBarChartComponent({ usersChartData, hideXAxis = false, min_max }: IBarChart) {
  return (
    <ResponsiveContainer width={"100%"} height={62} className="chartContainer">
      <BarChart
        layout="vertical"
        data={usersChartData}
        margin={{
          top: 10,
          right: usersChartData[0].value === chartMaxValues[ChartDataType.ptr5] ? 20 : 0,
          left: 5,
          bottom: 0,
        }}
      >
        <XAxis
          hide={hideXAxis}
          type="number"
          scale={"linear"}
          orientation={"bottom"}
          tick={{ textAnchor: "start", dx: -4 }}
          domain={min_max ? min_max : ([min]) => [Math.min(0, min), chartMaxValues[ChartDataType.ptr5]]}
          ticks={min_max ? [min_max[0], min_max[1]] : [0, chartMaxValues[ChartDataType.ptr5]]}
          axisLine={false}
          tickLine={false}
        />
        <YAxis hide={true} type="category" width={0} tickLine={false} axisLine={false} />
        <Bar radius={10} dataKey={"value"} background={{ fill: "#D9D9D9", radius: 8 }}>
          <LabelList dataKey="value" position="top" content={<CustomLabel />} />
          <Cell
            fill={(() => {
              const variant = getStrengthFromScore(usersChartData[0].value);
              switch (variant) {
                case "WEAK":
                  return BUCKET_COLORS.low;
                case "AVERAGE":
                  return BUCKET_COLORS.medium;
                case "STRONG":
                  return BUCKET_COLORS.high;
                default:
                  return BUCKET_COLORS.low;
              }
            })()}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
